// @flow
import React from 'react';
import LineString from 'ol/geom/LineString';
import type { Target } from '../../../../types';
import { fromLatLon } from '../../../../utils';
import { Feature, useMap } from '../../../ui/openlayers';
import useNow from '../../../../hooks/useNow';
import { useTrailsLayer } from './context';

const MAX_TRAIL_LENGTH = 130;
const POSITION_TTL = 10000;
const PROPERTIES = {
    type: 'trail'
};

const getCoordinates = (buffer: $ReadOnlyArray<Target>, now) => {
    const coordinates = [];
    for(let i = 0, length = buffer.length; i < length; i += 1) {
        const target = buffer[i];
        if(target.MovementData && target.MovementData.Position && (!now || target.TimeOfTrackInformation && (now - new Date(target.TimeOfTrackInformation)) < POSITION_TTL) ) {
            coordinates.push(fromLatLon(target.MovementData.Position));
        }
    }

    return coordinates;
};

type Props = $ReadOnly<{
    buffer: $ReadOnlyArray<Target>
}>;
function Trail({ buffer }: Props) {
    const map = useMap();
    const now = useNow(Math.max(POSITION_TTL / 3, 1000));
    const layer = useTrailsLayer();
    const view = map && map.getView();
    const resolution = Math.max(view ? view.getResolution() : 4, 1);

    if(!buffer || buffer.length < 2) {
        return null;
    }

    const coordinates = getCoordinates(buffer, now);

    if(coordinates.length === 0) {
        return null;
    }

    const geometry = new LineString(coordinates);
    while(coordinates.length > 2 && geometry.getLength() > (MAX_TRAIL_LENGTH * resolution)) {
        coordinates.pop();
        geometry.setCoordinates(coordinates);
    }

    return (
        <Feature
            geometry={geometry}
            properties={PROPERTIES}
            layer={layer}
        />
    );
}

export default Trail;